import styled, { css } from 'styled-components';

export const Container = styled.div`
  ${({ theme: { spacing } }) => css`
    display: grid;
    grid-gap: ${spacing.km4};
    justify-items: start;
    grid-template-rows: min-content min-content auto;
  `}
`;

export const ChildrenContainer = styled(Container)`
  ${({ theme: { spacing } }) => css`
    grid-gap: ${spacing.km2};
    align-content: space-between;
    grid-template-rows: auto;
  `}
`;
